import { gql } from "@apollo/client";

const GET_EXHIBITION_DOCUMENT_UPLOAD_URLS = gql`
  query GetExhibitionDocumentUploadUrls(
    $exhibitionId: Int!
    $filenames: [String]!
  ) {
    getExhibitionDocumentUploadUrls(
      exhibitionId: $exhibitionId
      filenames: $filenames
    ) {
      success
      error
      urls {
        url
        key
        filename
      }
    }
  }
`;

const DELETE_EXHIBITION_DOCUMENT = gql`
  mutation DeleteExhibitionDocument($input: DeleteExhibitionDocumentInput!) {
    deleteExhibitionDocument(input: $input) {
      success
      error
    }
  }
`;

export { GET_EXHIBITION_DOCUMENT_UPLOAD_URLS, DELETE_EXHIBITION_DOCUMENT };
